export default __webpack_public_path__ + "assets/images/10.70c385.webp";